import { Grid, Loader, Table } from "semantic-ui-react";

import { MdClose, MdModeEditOutline, MdSave } from "react-icons/md";
import { InputNumber } from "../../../../components/InputText/InputNumber";
import InputWithDropDown from "../../../../components/inputWithDropDown/InputWithDropDown";
import { GateType, WEIGHT_UNIT_TYPES_OPTIONs } from "../../../../config/constants";
import { checkValueIsEmpty } from "../../../../utils/utils";
import "./processContent.scss";

export const contentEdit = (
  dataIndex: any,
  groupIndex: any,
  currentRow: any,
  rowLength: any,
  processOrFarmGateName: any,
  gateType: any,
  data: any,
  inputUnit: any,
  selectProcess: any,
  control: any,
  errors: any,
  setSelectProcess: any,
  inputUnitTypes: any,
  setInputUnitTypes: any,
  outputUnitTypes: any,
  setOutputUnitTypes: any,
  handleSubmit: any,
  putProcessGateProcessData: any,
  isUpdateProcessLoading: any,
  putFarmGateProcessData: any,
  isUpdateFarmGateLoading: any,
  outputUnit: any,
  refetch: any,
  reset: any,
  isEditable: any
) => {
  const isSelectProcess = selectProcess?._id === data?._id;

  const editData = (data: any) => {
    setSelectProcess(data);
    setInputUnitTypes(data?.inputUnit);
    setOutputUnitTypes(data?.outputUnit);
  };

  const resetAndGetData = () => {
    setSelectProcess(null);
    refetch();
  };

  const saveData = (data: any) => {
    const updateProcessData = {
      ...data,

      processId: data?._id,
      facilityId: data?.facilityId?._id,
      inputUnit: inputUnitTypes,
      outputUnit: outputUnitTypes
    };

    if (gateType === GateType.ProcessGate) {
      putProcessGateProcessData(updateProcessData, {
        onSuccess: () => resetAndGetData()
      });
    } else {
      putFarmGateProcessData(updateProcessData, {
        onSuccess: () => resetAndGetData()
      });
    }
  };

  const handleCancel = () => {
    setSelectProcess(null);
    reset();
  };

  return (
    <Table.Row key={`${dataIndex}-${groupIndex}-empty`}>
      {currentRow === 0 && (
        <Table.Cell rowSpan={rowLength}>
          {processOrFarmGateName} ({gateType})
        </Table.Cell>
      )}
      <Table.Cell>{data?.processingName}</Table.Cell>
      <Table.Cell className={checkValueIsEmpty(data?.capacity)}>
        {isSelectProcess ? (
          <InputNumber
            transform={{
              input: (value: any) =>
                value === null || value === undefined || isNaN(value) ? "" : value.toString(),
              output: (e: any) => e
            }}
            control={control}
            placeholder="Capacity"
            name={"capacity"}
            errors={errors?.["capacity"]}
            required
            errorMessage="Capacity is required"
          />
        ) : (
          data?.capacity
        )}
      </Table.Cell>
      <Table.Cell className={checkValueIsEmpty(data?.input)}>
        {isSelectProcess ? (
          <InputWithDropDown
            defaultSelectValue={inputUnitTypes}
            options={WEIGHT_UNIT_TYPES_OPTIONs}
            selectOption={(value: string | number) => setInputUnitTypes(value)}
            control={control}
            placeholder="Input"
            name={`input`}
            errors={errors?.input}
            upward
            errorMessage="Input is required"
            customText="customProcessReviewInput"
            valueAsNumber={true}
            customRequired={true}
            required={true}
            transform={{
              input: (value: any) => (isNaN(value) || value === 0 ? "" : value.toString()),
              output: (e: any) => {
                return e;
              }
            }}
          />
        ) : (
          `${data?.input} ${inputUnit?.text}`
        )}
      </Table.Cell>
      <Table.Cell className={checkValueIsEmpty(data?.output)}>
        {isSelectProcess ? (
          <InputWithDropDown
            defaultSelectValue={outputUnitTypes}
            options={WEIGHT_UNIT_TYPES_OPTIONs}
            selectOption={(value: string | number) => setOutputUnitTypes(value)}
            control={control}
            placeholder="Output"
            name={`output`}
            upward
            errors={errors?.output}
            errorMessage="Output is required"
            customText="customProcessReviewInput"
            valueAsNumber={true}
            required={true}
            transform={{
              input: (value: any) => (isNaN(value) || value === 0 ? "" : value.toString()),
              output: (e: any) => {
                return e;
              }
            }}
          />
        ) : (
          `${data?.output} ${outputUnit?.text}`
        )}
      </Table.Cell>
      <Table.Cell>
        {isSelectProcess ? (
          <InputNumber
            transform={{
              input: (value: any) =>
                value === null || value === undefined || isNaN(value) ? "" : value.toString(),
              output: (e: any) => e
            }}
            control={control}
            placeholder="Side Stream"
            name={"sideStream"}
            errors={errors?.["sideStream"]}
            required
            errorMessage="Side Stream is required"
          />
        ) : (
          data?.sideStream
        )}
      </Table.Cell>
      <Table.Cell>
        {isSelectProcess ? (
          <InputNumber
            transform={{
              input: (value: any) =>
                value === null || value === undefined || isNaN(value) ? "" : value.toString(),
              output: (e: any) => e
            }}
            control={control}
            placeholder="Electricity"
            name={"electricity"}
            errors={errors?.["electricity"]}
            required
            errorMessage="Electricity is required"
          />
        ) : (
          data?.electricity
        )}
      </Table.Cell>
      <Table.Cell>
        {isSelectProcess ? (
          <InputNumber
            transform={{
              input: (value: any) =>
                value === null || value === undefined || isNaN(value) ? "" : value.toString(),
              output: (e: any) => e
            }}
            control={control}
            placeholder="Water"
            name={"water"}
            errors={errors?.["water"]}
            required
            errorMessage="Water is required"
          />
        ) : (
          data?.water
        )}
      </Table.Cell>
      <Table.Cell>
        {isSelectProcess ? (
          <InputNumber
            transform={{
              input: (value: any) =>
                value === null || value === undefined || isNaN(value) ? "" : value.toString(),
              output: (e: any) => e
            }}
            control={control}
            placeholder="Heat"
            name={"heat"}
            errors={errors?.["heat"]}
            required
            errorMessage="Heat is required"
          />
        ) : (
          data?.heat
        )}
      </Table.Cell>
      <Table.Cell>
        <Grid>
          <Grid.Column computer={4} tablet={16} mobile={16}>
            {(isUpdateProcessLoading || isUpdateFarmGateLoading) && isSelectProcess ? (
              <Loader active size="small" inline="centered" />
            ) : isSelectProcess ? (
              <MdSave
                cursor="pointer"
                size={24}
                color="var(--tableEditIcon)"
                title="Save"
                onClick={handleSubmit((data: any) => saveData(data))}
              />
            ) : (
              <>
                {isEditable && (
                  <MdModeEditOutline
                    cursor="pointer"
                    size={24}
                    color="var(--tableEditIcon)"
                    onClick={() => editData(data)}
                  />
                )}
              </>
            )}
          </Grid.Column>
          {!(isUpdateProcessLoading || isUpdateFarmGateLoading) && isSelectProcess ? (
            <Grid.Column computer={4} tablet={16} mobile={16}>
              <MdClose
                cursor={"pointer"}
                size={24}
                color="var(--tableEditIcon)"
                onClick={handleCancel}
              />
            </Grid.Column>
          ) : null}
        </Grid>
      </Table.Cell>
    </Table.Row>
  );
};
